import { createGlobalStyle } from 'styled-components';
import { SIDEBAR_WIDTH } from '../Sidebar/constants';

const GlobalStyles = createGlobalStyle`
  /** Heavy */
  @font-face {
    font-family: 'SF Display Heavy';
    font-weight: 800;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/sf-pro-text-heavy.woff') format('woff');
  }

  /** Bold */
  @font-face {
    font-family: 'SF Display Bold';
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/sf-pro-text-bold.woff') format('woff');
  }

  /** Medium */
  @font-face {
    font-family: 'SF Display Medium';
    font-weight: 500;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/sf-pro-text-medium.woff') format('woff');
  }

  /** Regular */
  @font-face {
    font-family: 'SF Display Regular';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/sf-pro-text-regular.woff') format('woff');
  }

  /** Light */
  @font-face {
    font-family: 'SF Display Light';
    font-weight: 200;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/sf-pro-text-light.woff') format('woff');
  }

  /** Semi bold */
  @font-face {
    font-family: 'SF Display Semi bold';
    font-weight: 600;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/sf-pro-text-semibold.woff') format('woff');
  }

  :root {
    color-scheme: light;
    --lms-canvas: #f3f5f7;
    --lms-surface: #ffffff;
    --lms-text: #1f2933;
    --lms-muted: #5f6b76;
    --lms-border: #d9e0e7;
    --lms-action: #30343a;
    --lms-action-hover: #202327;
    --lms-focus: #4b5563;
    --lms-selection: #e7e9ec;
  }

  html {
    scrollbar-gutter: stable;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    color: var(--lms-text);
    background: var(--lms-canvas);
    font-family: 'SF Display Regular', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
    -webkit-font-smoothing: antialiased;
  }

  ::selection {
    color: var(--lms-text);
    background: var(--lms-selection);
  }

  p,h3,h4 {
    margin: 0px;
    padding: 0px;
  }

  button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
  }

  button:disabled {
    cursor: not-allowed;
  }

  :focus-visible {
    outline: 3px solid var(--lms-focus);
    outline-offset: 3px;
  }
  
  #app  .ant-layout {
    min-height: 100vh;
  }
  
  .ant-form-item {
    margin-bottom: 0 !important;
  }
  
  .ant-form-item-control {
    line-height: initial !important;
  }

  .ant-select {
    width: 100%;
  }

  .ant-btn-primary {
    background-color: var(--lms-action) !important;
    border-color: var(--lms-action) !important;
  }

  .ant-btn-primary:hover,
  .ant-btn-primary:focus,
  .ant-btn-primary:active {
    background-color: var(--lms-action-hover) !important;
    border-color: var(--lms-action-hover) !important;
  }

  .ant-skeleton-paragraph {
    padding: 0;
  }

  .ant-table-tbody > tr > td {
    overflow-wrap: normal;
    vertical-align: top;
    word-break: normal;
    white-space: normal;
  }

  .ant-table-thead > tr > th {
    overflow-wrap: normal;
    white-space: nowrap;
  }

  .ant-table-body,
  .ant-table-content {
    max-width: 100%;
    overflow-x: auto;
    overscroll-behavior-inline: contain;
  }

  .custom-td {
    padding: 0 !important;
    text-align: center !important;
    height: 1px;  
  }

  .attendance .ant-select-selection {
    border-color: #949292 !important;
  }
  
  .ant-table-title {
    display: grid;
    justify-content: flex-end;
  }
  
  .ant-calendar-picker {
    width: 100%;
  }

  .ant-time-picker {
    width: 100% !important;
  }

  .attendance .ant-select-selection {
    border-color: #949292 !important;
  }

  *[data-keypad="number"] {
    -webkit-text-security: disc;
  }
  
  .ant-checkbox-group { 
    display: grid !important;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 5px;
    margin-top: 5px !important;
  }

  .ant-menu-item,
  .ant-menu-submenu-title {
    height: auto !important;
    min-height: 48px;
    padding-top: 14px !important;
    padding-bottom: 14px !important;
    line-height: 20px !important;
    white-space: normal;
  }

  .ant-menu-item {
    padding-left: 35px !important;
  }

  .ant-menu-item a {
    overflow-wrap: anywhere;
    white-space: normal;
  }

  .ant-calendar-picker-input {
    background-color: #fff !important; 
    color: rgba(0, 0, 0, 0.65) !important;
    cursor: default !important;
  }

  .ant-radio-inner {
    width: 18px !important;
    height: 18px !important;
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #222 !important;
  }

  .ant-radio-inner::after {
    background-color: #222 !important;
    width: 10px !important;
    height: 10px !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #222 !important;
    border-color: #222 !important;
  }

  .ant-checkbox-inner {
      width: 21px !important;
      height: 21px !important;
  }

  .ant-checkbox-inner::after {
    left: 30% !important;
  }

  .ant-modal-wrap {
    left: 19px;
    right: 19px;
  }

  .ant-modal-body {
    padding: 25px 52px !important;
  }

  .ant-modal-close {
    display: none;
  }

  .ant-layout-sider-children {
    position: fixed;
    width: ${SIDEBAR_WIDTH}px;
    max-width: ${SIDEBAR_WIDTH}px;
    overflow-y: scroll;
  }

  .ant-layout-sider {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    height: 100vh;
    z-index: 2;
  }

  .ant-layout-sider + * {
    flex: 0 1 calc(100% - ${SIDEBAR_WIDTH}px);
    width: calc(100% - ${SIDEBAR_WIDTH}px);
    max-width: calc(100% - ${SIDEBAR_WIDTH}px);
    min-width: 0;
    margin-left: ${SIDEBAR_WIDTH}px;
  }

  .ant-layout-sider[style*='display: none'] + * {
    flex-basis: 100%;
    width: 100%;
    max-width: 100%;
    margin-left: 0;
  }

  @media (max-width: 991px) {
    .ant-layout-sider + * {
      margin-left: ${SIDEBAR_WIDTH}px;
    }

    .ant-layout-sider-zero-width + * {
      flex-basis: 100%;
      width: 100%;
      max-width: 100%;
      margin-left: 0;
    }

    .ant-layout-sider-zero-width .ant-layout-sider-children {
      width: 0;
      max-width: 0;
      overflow: hidden;
      visibility: hidden;
    }

    .ant-layout-sider-zero-width-trigger {
      position: fixed;
      top: 12px;
      left: 12px;
      z-index: 4;
      border: 1px solid var(--lms-border);
      border-radius: 6px;
    }

    .ant-modal-wrap {
      left: 0;
      right: 0;
    }

    .ant-modal-body {
      padding: 20px !important;
    }

    .ant-checkbox-group {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 767px) {
    input,
    textarea,
    select {
      font-size: 16px !important;
    }
  }

   #drivers_scores .ant-table-tbody > tr > td {
    white-space: normal !important;
  }
`;

export default GlobalStyles;
